module.exports = __webpack_public_path__ + "img/f84bbdc41bed1b9c2a32015388180e9f-lost_page_night.png";